module.exports = __webpack_public_path__ + "img/spider.be5030ca.webp";